<template>
    <div class="shop-content">
        <ph-header>
            <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
        </ph-header>
        <div class="freight-content">
            <img src="https://m.ponhu.cn/Public/wap/bing/images/youfei.png" alt="" srcset="">
        </div>
    </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
export default {
  name: 'shopFreight',
  components: {
    PhHeader
  }
}
</script>

<style lang="less" scoped>

</style>
